import React, { useState, useRef, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'
import logo from '../Image/logo.png'
import blog from '../Image/images (6).jpg'
import blog1 from '../Image/What-is-Digital-Marketing.png'
import badge from "../Image/badges-a.png"
import badge1 from "../Image/badges-b.png"
import badge2 from '../Image/badges-c.png'
import badge3 from '../Image/badges-d.png'

function PayDropdown({ btnRef, onClose }) {
    const dropRef = useRef(null)
    const [style, setStyle] = useState({ opacity: 0 })

    useEffect(() => {
        if (btnRef.current) {
            const rect = btnRef.current.getBoundingClientRect()
            const dropWidth = 310
            const spaceRight = window.innerWidth - rect.right
            const spaceLeft = rect.left

            let left
            if (spaceRight >= dropWidth + 10) {
                // enough space on right — open to right
                left = rect.right + 8
            } else {
                // not enough on right — open to left
                left = rect.left - dropWidth - 8
            }

            // vertically align with button center
            const dropHeight = 180
            let top = rect.top + (rect.height / 2) - (dropHeight / 2)
            // clamp within viewport
            top = Math.max(10, Math.min(top, window.innerHeight - dropHeight - 10))

            setStyle({
                position: 'fixed',
                top: top,
                left: left,
                opacity: 1
            })
        }

        function handleClickOutside(e) {
            if (
                dropRef.current && !dropRef.current.contains(e.target) &&
                btnRef.current && !btnRef.current.contains(e.target)
            ) {
                onClose()
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        window.addEventListener('scroll', onClose)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            window.removeEventListener('scroll', onClose)
        }
    }, [])

    return ReactDOM.createPortal(
        <div
            ref={dropRef}
            style={{
                ...style,
                background: '#ffffff',
                borderRadius: '16px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.22), 0 4px 16px rgba(0,0,0,0.08)',
                border: '1px solid rgba(0,0,0,0.07)',
                zIndex: 999999,
                width: '260px',
                overflow: 'hidden',
                fontFamily: 'inherit',
                transition: 'opacity 0.18s ease, transform 0.18s ease',
                transform: style.opacity === 1 ? 'scale(1)' : 'scale(0.95)'
            }}
        >
            {/* Header */}
            <div style={{
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                padding: '14px 18px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}>
                <div style={{
                    width: '28px', height: '28px',
                    background: 'rgba(255,255,255,0.12)',
                    borderRadius: '8px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <i className="fas fa-wallet" style={{ color: '#fff', fontSize: '12px' }}></i>
                </div>
                <div>
                    <p style={{ margin: 0, fontSize: '12px', fontWeight: '700', color: '#fff', lineHeight: 1.2 }}>Pay Online</p>
                    <p style={{ margin: 0, fontSize: '9px', color: 'rgba(255,255,255,0.5)', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Select payment gateway</p>
                </div>
            </div>

            {/* Options */}
            <div style={{ padding: '10px 10px', display: 'flex', flexDirection: 'column', gap: '6px', background: '#fff' }}>

                {/* Razorpay */}
                <a
                    href="https://rzp.io/l/pAQuTAJo6n"
                    target="_blank"
                    rel="noreferrer"
                    onClick={onClose}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px 14px',
                        textDecoration: 'none',
                        borderRadius: '12px',
                        border: '1.5px solid #e8f0fe',
                        background: '#f8fbff',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer'
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.background = '#e8f0fe'
                        e.currentTarget.style.borderColor = '#3b82f6'
                        e.currentTarget.style.transform = 'translateX(3px)'
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.background = '#f8fbff'
                        e.currentTarget.style.borderColor = '#e8f0fe'
                        e.currentTarget.style.transform = 'translateX(0)'
                    }}
                >
                    <div style={{
                        width: '42px', height: '42px', flexShrink: 0,
                        background: 'linear-gradient(135deg, #1d4ed8, #60a5fa)',
                        borderRadius: '11px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        boxShadow: '0 4px 12px rgba(29,78,216,0.35)'
                    }}>
                        <i className="fas fa-bolt" style={{ color: '#fff', fontSize: '16px' }}></i>
                    </div>
                    <div style={{ flex: 1 }}>
                        <strong style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#1d4ed8', marginBottom: '2px' }}>
                            Razorpay
                        </strong>
                        <small style={{ fontSize: '10px', color: '#94a3b8' }}>
                            Cards · UPI · Net Banking · Wallet
                        </small>
                    </div>
                    <i className="fas fa-chevron-right" style={{ color: '#3b82f6', fontSize: '10px' }}></i>
                </a>

                {/* PhonePe */}
                <a
                    href="/phonepe-pay"
                    target="_blank"
                    rel="noreferrer"
                    onClick={onClose}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px 14px',
                        textDecoration: 'none',
                        borderRadius: '12px',
                        border: '1.5px solid #ede9fe',
                        background: '#faf8ff',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer'
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.background = '#ede9fe'
                        e.currentTarget.style.borderColor = '#8b5cf6'
                        e.currentTarget.style.transform = 'translateX(3px)'
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.background = '#faf8ff'
                        e.currentTarget.style.borderColor = '#ede9fe'
                        e.currentTarget.style.transform = 'translateX(0)'
                    }}
                >
                    <div style={{
                        width: '42px', height: '42px', flexShrink: 0,
                        background: 'linear-gradient(135deg, #5b21b6, #a78bfa)',
                        borderRadius: '11px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        boxShadow: '0 4px 12px rgba(91,33,182,0.35)'
                    }}>
                        <i className="fas fa-mobile-alt" style={{ color: '#fff', fontSize: '16px' }}></i>
                    </div>
                    <div style={{ flex: 1 }}>
                        <strong style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#5b21b6', marginBottom: '2px' }}>
                            PhonePe
                        </strong>
                        <small style={{ fontSize: '10px', color: '#94a3b8' }}>
                            UPI · Wallet · Bank Transfer
                        </small>
                    </div>
                    <i className="fas fa-chevron-right" style={{ color: '#8b5cf6', fontSize: '10px' }}></i>
                </a>

            </div>

            {/* Secure Footer */}
            <div style={{
                padding: '8px 14px 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '5px'
            }}>
                <i className="fas fa-shield-alt" style={{ color: '#22c55e', fontSize: '10px' }}></i>
                <small style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '500' }}>
                    256-bit SSL Encrypted &amp; 100% Secure
                </small>
            </div>

        </div>,
        document.body
    )
}

function Footer() {
    const [payDropOpen, setPayDropOpen] = useState(false)
    const btnRef = useRef(null)

    return (
        <>
            <footer>
                <div className="footer-row1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="email-subs">
                                    <h3>Get New Insights Weekly</h3>
                                    <p>Get our latest article and new tech information directly in your mail.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 v-center">
                                <div className="email-subs-form">
                                    <form>
                                        <input type="email" placeholder="Email Your Address" name="emails" />
                                        <button type="submit" name="submit" className="lnk btn-main bg-btn">Subscribe <i
                                            className="fas fa-chevron-right fa-icon"></i><span className="circle"></span></button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-row2">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-3 col-sm-6  ftr-brand-pp">
                                <a className="navbar-brand mt30 mb25 f-dark-logo" href="#"> <img src={logo}
                                    alt="Logo" style={{ width: "150px" }} /></a>
                                <a className="navbar-brand mt30 mb25 f-white-logo" href="#"> <img src={logo}
                                    alt="Logo" style={{ width: "150px" }} /></a>
                                <p>We make experience that are alluring, easy to utilize, and drive results for your organization. We are not your typical web development organization.</p>

                                {/* Pay Online Dropdown Button */}
                                <div style={{ display: 'inline-block', marginTop: '20px', position: 'relative' }}>
                                    <button
                                        ref={btnRef}
                                        onClick={() => setPayDropOpen(prev => !prev)}
                                        className="btn-main bg-btn3 lnk"
                                        style={{ cursor: 'pointer', border: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}
                                        title="Pay Online Here"
                                    >
                                        Pay Online
                                        <i className={`fas fa-chevron-${payDropOpen ? 'up' : 'down'} fa-icon`}></i>
                                        <span className="circle"></span>
                                    </button>

                                    {payDropOpen && (
                                        <PayDropdown
                                            btnRef={btnRef}
                                            onClose={() => setPayDropOpen(false)}
                                        />
                                    )}
                                </div>

                            </div>
                            <div className="col-lg-3 col-sm-6">
                                <h5>Contact Us</h5>
                                <ul className="footer-address-list ftr-details">
                                    <li>
                                        <span><i className="fas fa-envelope"></i></span>
                                        <p>Email <span> <a href="mailto:info@ndtechland.com">info@ndtechland.com</a></span>
                                        </p>
                                    </li>
                                    <li>
                                        <span><i className="fas fa-phone-alt"></i></span>
                                        <p>Phone <span> <a href="tel:+918826302378">+91 8826302378</a></span></p>
                                    </li>
                                    <li>
                                        <span><i className="fas fa-map-marker-alt"></i></span>
                                        <p>Address <span>
                                            D-159, First Floor, Sector 7, Noida, Uttar Pradesh-201301</span></p>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-sm-6">
                                <h5>Company</h5>
                                <ul className="footer-address-list link-hover">
                                    <li><a target="_blank" href="https://organicdeal.in/">Organic Deal</a></li>
                                    <li><a target="_blank" href="https://ndinfotech.com/">N D Infotech</a></li>
                                    <li><Link to="/Faq">Customer's FAQ</Link></li>
                                    <li><Link to="/Privacypolicy">Privacy Policy</Link></li>
                                    <li><Link to="/Termsconditions">Terms and Conditions</Link></li>
                                    <li><Link to="/Refundpolicy">Refund Policy</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-sm-6 footer-blog-">
                                <h5>Latest Blogs</h5>
                                <div className="single-blog-">
                                    <div className="post-thumb"><a href="#"><img src={blog} alt="blog" /></a>
                                    </div>
                                    <div className="content">
                                        <p className="post-meta"><span className="post-date"><i className="far fa-clock"></i>April 15,
                                            2023</span></p>
                                        <h4 className="title"><a href="#!">We Provide you Best &amp; Creative
                                            Consulting Service</a></h4>
                                    </div>
                                </div>
                                <div className="single-blog-">
                                    <div className="post-thumb"><Link to="/blog"><img src={blog1} alt="blog" /></Link>
                                    </div>
                                    <div className="content">
                                        <p className="post-meta"><span className="post-date"><i className="far fa-clock"></i>April 21,
                                            2023</span></p>
                                        <h4 className="title"><Link to="/blog">We Provide you Best &amp; Creative
                                            Consulting Service</Link></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-brands">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 v-center">
                                <h5 className="mb10">App &amp; E-Commerce Development</h5>
                                <p>Web Portal Development, Mobile Application Development, E-Commerce Development, Digital Marketing</p>
                            </div>
                            <div className="col-lg-8 v-center">
                                <ul className="footer-badges-">
                                    <li><a href="#"><img src={badge} alt="badges" /></a></li>
                                    <li><a href="#"><img src={badge1} alt="badges" /></a></li>
                                    <li><a href="#"><img src={badge3} alt="badges" /></a></li>
                                    <li><a href="#"><img src={badge2} alt="badges" /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-row3">
                    <div className="copyright">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="footer-social-media-icons">
                                        <a href="https://in.linkedin.com/company/nd-techland" target="_blank"><i className="fab fa-linkedin"></i></a>
                                        <a href="https://www.facebook.com/ndtechland/" target="_blank"><i className="fab fa-facebook"></i></a>
                                        <a href="https://www.instagram.com/ndtechland/" target="_blank"><i className="fab fa-instagram"></i></a>
                                        <a href="https://youtube.com/@ndtechland8327?si=vydSyff0Wu6sC2iv" target="_blank"><i className="fab fa-youtube"></i></a>
                                    </div>
                                    <div className="footer-">
                                        <p>©2024. All Rights Reserved By  <a
                                            href="www.info@ndtechland.com" target="blank">ND Techland</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer